import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import './index.css'
import { Link } from 'react-router-dom'
import ButtonPurple from 'components/design/Form/ButtonPurple'

const ModalAISettings = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const handleConfigure = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
    
  }

  const { visibleModalID } = settings
  const modalID = 'openAISettings'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="custom__success__modal"
      title={<div>Enable OpenAI Settings to Use This Feature</div>}
      onCancel={handleCancel}
      afterClose={handleCancel}
      open={visible}
      footer={null}
      maskClosable={false}
    >
      <div className="p-0 gap-4">
        <div className="mb-2">
          {' '}
          To activate this feature, you’ll need to enable OpenAI Settings first.
          Click below to configure your settings, then come back to turn on this feature.
        </div>
        <Link to="openai">
          <ButtonPurple onClick={handleConfigure} buttonText="Configure OpenAI Settings" />
        </Link>
      </div>
    </Modal>
  )
}

export default ModalAISettings
